<form [formGroup]="secondFormGroup">
    <ng-template matStepLabel>Identificación</ng-template>
    <div class="row">
        <div class="col-lg-12">
            <strong>
                <p class="title_datos">Ingrese la Dirección</p>
            </strong>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm--12 div_rol">
            <p>Rol</p>
            <mat-form-field class="mat-field-calle">
                <input class="mat_input" matInput placeholder="(ej: 279-10)" [formControl]="rol">
                <button mat-button style="margin: 0px;" *ngIf="secondFormGroup.controls.rol.value" matSuffix
                    mat-icon-button aria-label="Clear" (click)="secondFormGroup.controls?.rol.setValue('')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <button mat-raised-button color="primary" (click)="buscar_info_propiedad_rol()"
                [disabled]="!rol.valid || !buscarbtn">Buscar por Rol <i class="material-icons">search</i></button>
        </div>
    </div>
    <div class="row" *ngIf="bandera">
        <div class="ccol-lg-12 col-md-12 col-sm--12 div_dir">
            <p>Dirección</p>
            <mat-form-field class="mat-field-calle">
                <input matInput type="text" placeholder="Calle" formControlName="dir" [matAutocomplete]="auto">
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                        {{option}}
                    </mat-option>
                </mat-autocomplete>
                <button mat-button style="margin: 0px;" *ngIf="secondFormGroup.controls?.dir.value" matSuffix
                    mat-icon-button aria-label="Clear" (click)="secondFormGroup.controls?.dir.setValue('')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field class="mat-field-calle">
                <input class="mat_input" matInput placeholder="Número" [formControl]="num">
                <button mat-button style="margin: 0px" *ngIf="secondFormGroup.controls?.num.value" matSuffix
                    mat-icon-button aria-label="Clear" (click)="secondFormGroup.controls?.num.setValue('')">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>


            <button mat-raised-button color="primary" (click)="buscar_info_propiedad_direccion()"
                [disabled]="(!num.valid || !dir.valid) || !buscarbtn">Buscar por Dirección <i
                    class="material-icons">search</i></button>
        </div>
    </div>
    <div class="row" style="padding-top: 40px; padding-bottom: 30px;">
        <div class="col-lg-12">
            <table class="col-md-12" mat-table [dataSource]="lista_dir" class="mat-elevation-z8">
                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                <!-- Position Column -->
                <ng-container matColumnDef="rol">
                    <th mat-header-cell *matHeaderCellDef style="width: 30%"> <strong>Rol</strong>
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.rol}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="direccion">
                    <th mat-header-cell *matHeaderCellDef style="width: 60%"><strong>Nombre</strong>
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.direcCompleta}}
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%"><strong>Opción</strong>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index"><button mat-raised-button color="primary"
                            (click)="eliminar_direccion(i)">Eliminar</button></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6" align="left">
            <button class="btn_l" mat-raised-button color="primary" matStepperPrevious>Volver</button>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6" align="right">
            <!--!dirs || dirs===null || dirs===undefined || dirs.length===0 || -->
            <button class="btn_r" [disabled]="btnContinuar==false" mat-raised-button color="primary"
                matStepperNext>Continuar</button>
        </div>
    </div>
</form>

<ng-template #direccionesDialog>
    <h2 style="color: tomato;" mat-dialog-title>Direcciones existentes en el rol</h2>
    <!-- <label id="example-radio-group-label">Seleccione una dirección:</label> -->
    <mat-dialog-content style="width: 400px;
    overflow: hidden auto;">
        <br>
        <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            <strong> Debe seleccionar una de las direcciones</strong>
        </div>
        <div id="search-box-div" style="text-align: center; padding-bottom: 5px;">
            <div id="search-field" class="top-div">
                <input #input type="text" placeholder="Buscar" [(ngModel)]="searchText">
            </div>
        </div>
        <ul class="list-group">
            <li class="list-group-item"
                *ngFor="let dir of dires | filter: searchText | paginate: {itemsPerPage: 10, currentPage: p}">

                <input type="radio" id="direccionSelec" name="direccionSelect" [value]="dir" name="modal_dir"
                    [(ngModel)]="dirSeleccionada">
                <span style="margin-left: 4px;">{{dir.direcCompleta}}</span><span style="float: right;">{{
                    dir.rol }}</span>
            </li>
        </ul>
        <div style="text-align:center">
            <pagination-controls [nextLabel]="'Siguiente'" [previousLabel]="'Anterior'" (pageChange)="p = $event">
            </pagination-controls>
        </div>
        <!-- <mat-radio-group aria-labelledby="example-radio-group-label" [(ngModel)]="dirSeleccionada"
            class="example-radio-group">
            <div class="row">
                <mat-radio-button class="example-radio-button" *ngFor="let dir of dirrecciones.dirs" [value]="dir">
                    {{ dir.direcCompleta }}
                </mat-radio-button>
            </div>
        </mat-radio-group> -->
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet"
            data-dismiss="modal">Cancelar</button>
        <button mat-raised-button color="primary" id="ingreso_propiet" (click)="insertarDir()">Ingresar Propiedad <i
                class="fa fa-user-o" aria-hidden="true"></i></button>
    </mat-dialog-actions>
</ng-template>